










































import { configureApi } from '@/libs/api'
import { defineComponent, ref } from '@vue/composition-api'
import { envs } from '@/config/envs'
import { getClientId, getOrganisationId, getStoreId } from '@futureecom/futureecom-js/dist/helpers/auth/auth-helpers'
import { useApi } from '@/composable/useApi'
import { useAuth } from '@/composable/useAuth'
import { useRoute } from '@/composable/migrateUseRoute'
import { useRouter } from '@intlify/vue-router-bridge'
import { useToasts } from '@/composable/useToasts'
import { useValidator } from '@/composable/validator/useValidator'
import LoginInputs from '@/components/login/LoginInputs.vue'
import type { RuleDefinitions } from '@/types/validator'
import type { TokenRequestPassword } from '@futureecom/futureecom-js/dist/services/auth-service'

export default defineComponent({
  name: 'Login',

  components: { LoginInputs },

  setup() {
    const router = useRouter()
    const route = useRoute()

    const { addErrorToast } = useToasts()
    const { setAccessToken, setRefreshToken, setRefreshTenancyKeys } = useAuth()

    const loading = ref(false)

    const item = ref<TokenRequestPassword>({
      client_id: envs().API.CLIENT_ID || undefined,
      grant_type: 'password',
      username: '',
      password: ''
    })

    const { errors, validate, isValid } = useValidator(item.value)

    const rules: RuleDefinitions = {
      username: ['required'],
      password: ['required']
    }

    const onItemChange = () => validate(item.value, rules)

    const submitHandler = (): void => {
      validate(item.value, rules, true)

      if (!isValid.value) {
        return
      }

      loading.value = true

      useApi()
        .auth.login(item.value)
        .then(({ access_token, refresh_token }) => {
          const clientId: string | undefined = getClientId(access_token)
          const tokenOrg: number | undefined = getOrganisationId(access_token)
          const tokenStore: number | undefined = getStoreId(access_token)

          setAccessToken(access_token)
          setRefreshToken(refresh_token)
          setRefreshTenancyKeys({ organisation: tokenOrg || 0, store: tokenStore })

          configureApi(clientId, tokenOrg)

          const dashboardRoute = { name: 'dashboard', params: { organisation: `${tokenOrg}` || '', store: '1' } }
          router.push(route.params.redirect || dashboardRoute)
        })
        .catch((err: any) => addErrorToast(err.response?.data.message))
        .finally(() => (loading.value = false))
    }

    return {
      loading,
      item,
      errors,
      isValid,
      onItemChange,
      submitHandler
    }
  }
})
